import React from 'react'
import '../orgChart.scss'

const TeamTabs = ({ teams, selectedTeam, onTeamSelect }) => {
  return (
    <div className="org-chart-tabs">
      {teams.map((team) => (
        <button
          key={team.id}
          className={`org-chart-tab ${selectedTeam === team.id ? 'active' : ''}`}
          onClick={() => onTeamSelect(team.id)}
        >
          {team.name}
        </button>
      ))}
    </div>
  )
}

export default TeamTabs
